import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

interface AlreadyInBasketModalProperties {
    readonly basketPageUrl: string;
    readonly modalIsOpen: boolean;
    readonly closeModal: () => void;
    readonly onAfterClose: () => void;
}

export default function AlreadyInBasketModal({
    basketPageUrl,
    modalIsOpen,
    closeModal,
    onAfterClose,
}: AlreadyInBasketModalProperties): React.JSX.Element {
    const { t } = useTranslation("basket");

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-dialog cart-modal-info modal-width-fix"
            overlayClassName="react-modal-backdrop modal-transition"
            closeTimeoutMS={150}
            onAfterClose={(): void => onAfterClose()}
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className="already-in-cart">
                            <div className="cart-modal-info-box">
                                <p className="fakeh3"><i className="fa-solid fa-exclamation-circle"></i> {t("attention")}
                                </p>
                                <p>{t("allItemsInCart")}</p>
                            </div>
                            <div className="modal-error-button">
                                <a className="btn btn-success btn-lg" href={basketPageUrl}>{t("goToCart")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
